import React from "react";
import "./progressBar.scss";

interface Props {
  percentage?: string;
  height?: string;
  width?: string;
  fillColor?: string;
  loading?: boolean;
}

const ProgressBar = ({
  percentage = "0%",
  height = "6px",
  width = "300px",
  fillColor = "#73D7C3",
  loading = false,
}: Props) => {
  return (
    <div
      style={{ height, width }}
      className={`commonProgressBar_container ${loading ? "loading" : null}`}
    >
      {!loading && (
        <div
          className="commonProgressBar_fillWrapper"
          style={{ width: percentage }}
        >
          <div
            className="commonProgressBar_fill"
            style={{ background: fillColor }}
          />
        </div>
      )}
    </div>
  );
};

export default ProgressBar;
